module.exports = __webpack_public_path__ + "static/media/cancel-svgrepo-com.428a665e.svg";